import { ClientRegistrationDataResponseKeys } from './apiTypes';

export type DataCollectionRoom = {
    id: string;
    title: string;
    area: string;
    heated: boolean;
    recuperation: boolean;
};

export type DataCollectionFloor = {
    id: string;
    title: string;
    roomIds: Array<string>;
};

export type DataCollectionRoomsDistribution = {
    floors: { [id: string]: DataCollectionFloor };
    rooms: { [id: string]: DataCollectionRoom };
    floorsOrder: Array<string>;
};

/*
    name: string;
    surname: string;
    city: string;
    buildingPermit: string;
    heatLoss: string;
    heatLossSetting: 'known' | 'unknown' | 'project' | null;
    attic: string;
    garage: string;
    garageHeated: string;
    garagePartOfBuilding: string;
    recuperation: string;
    photovoltaics: string;
    roomsDistribution: DataCollectionRoomsDistribution;
    files: {
        floorCrossSection: File | null;
        roofCrossSection: File | null;
        wallCrossSection: File | null;
        floorPlan: File | null;
    };
    email: string;
    password: string;
    phone: string;
*/

export type DataCollectionValues = {
    area: string;
    region: string;
    buildingPhase: string;
    buildDate: string;
    approvalDate: string;
    knowHeatLoss: string;
    heatLoss: string;
    oldHeatSource: string;
    penB: string;
    penBType: string;
    measuredHeatLoss: string;
    buildingVolumeV: string;
    totalAreaOfBuildingEnvelope: string;
    averageHeatTransferCoefficient: string;
    lossByVentilation: string;
    lossByInfiltration: string;
    lossSummary: string;
    floorPlanShape: string;
    groundPlanType: string;
    roofType: string;
    floorCount: string;
    garageArea: string;
    basementArea: string;
    atticArea: string;
    bathroomCount: string;
    hasRecuperation: string;
    hasHeatedAttic: string;
    glazing: string;
    wallInsulation: string;
    wallInsulationThickness: string;
    floorInsulation: string;
    floorInsulationThickness: string;
    roofInsulation: string;
    roofInsulationThickness: string;
    photovoltaics: string;
    name: string;
    surname: string;
    email: string;
    phone: string;
    // old
    roomDispositions: string;
    roomsDistribution: DataCollectionRoomsDistribution;
    areaTotal: number;
    viessmann: boolean;
    electricInsulation: string;
    gasInsulation: string;
};

export type DataCollectionValuesKey = keyof DataCollectionValues;

export const INITIAL_DATA_COLLECTION_VALUES: DataCollectionValues = {
    area: '',
    region: '',
    buildingPhase: '',
    buildDate: '',
    approvalDate: '',
    knowHeatLoss: '',
    heatLoss: '',
    oldHeatSource: '',
    penB: '',
    penBType: '',
    measuredHeatLoss: '',
    buildingVolumeV: '',
    totalAreaOfBuildingEnvelope: '',
    averageHeatTransferCoefficient: '',
    lossByVentilation: '',
    lossByInfiltration: '',
    lossSummary: '',
    floorPlanShape: '',
    groundPlanType: '',
    roofType: '',
    floorCount: '',
    garageArea: '',
    basementArea: '',
    atticArea: '',
    bathroomCount: '',
    hasRecuperation: '',
    hasHeatedAttic: '',
    glazing: '',
    wallInsulation: '',
    wallInsulationThickness: '',
    floorInsulation: '',
    floorInsulationThickness: '',
    roofInsulation: '',
    roofInsulationThickness: '',
    photovoltaics: '',
    name: '',
    surname: '',
    email: '',
    phone: '',
    //OLD Wizard
    roomDispositions: '',
    roomsDistribution: {
        floors: {},
        rooms: {},
        floorsOrder: [],
    },
    areaTotal: 100,
    viessmann: false,
    electricInsulation: '',
    gasInsulation: '',
};

export type DataEnumeration = {
    value: string;
    title: string;
    img?: string;
    imgTc?: string;
    description?: string;
};

export type DataEnumerations = DataEnumeration[];

export type BasicInfoValues = {
    area: string;
    region: string;
    buildingPhase: string;
};
